import Image from 'next/image';

const DevImg = ({ containerStyles, imgSrc }) => {
  return (
    <div className={`${containerStyles}`}>
      <Image src={imgSrc} fill priority alt="Portfolio de Jérémie Deldem, développeur web fullstack" />
    </div>
  );
};

export default DevImg;
